(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-big-screen-plugin-app"] = factory();
	else
		root["vue-big-screen-plugin-app"] = factory();
})(self, function() {
return 